import React, { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { venuePath } from "../utils/routes";
import Map from "../Components/Map";
import "../Styles/Home.css"
import { startSpotifyLogin, getStoredToken, isTokenExpired, refreshAccessToken } from "../Services/SpotifyAuth";
import { getCurrentlyPlaying } from "../Services/SpotifyApi";
import Feed from "../Components/Feed";
import Header from "../Components/Header";
import { feed } from "../data/feedStub";
import { fetchFeed } from "../Services/FeedService";
import type { FeedObj ,FeedObjDTO } from "../data/types";

export default function Home() {
  const [feed, setFeed] = useState<FeedObj[]>([]);
  const [error, setError] = useState<string | null>(null);

  // Äldre länkar pekade på kartan med /?venue=<id>. Ett ställe har numera en
  // egen sida, så de skickas dit i stället för att öppna ett kort på kartan.
  const [params] = useSearchParams();
  const legacyVenueId = params.get("venue");

  useEffect(() => {
   // fetchFeed().then(setFeed).catch(() => setFeed([]));
  }, []);


  if (legacyVenueId) return <Navigate to={venuePath(legacyVenueId)} replace />;

  return (
    <div className="home-wrapper">
      <Header />
      <Map />
{/*       <Feed feedArr={feed}/> */}
    </div>
  );
}
